module.exports = __webpack_public_path__ + "img/machine_l_heading.d3e225e3.png";